/// <reference types="vite/client" />

import { createInertiaApp } from '@inertiajs/react';
import { renderApp } from '@inertiaui/modal-react';
import { createElement } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import AstryxProviders from '../components/astryx-providers';
import resolvePageLayout from '../lib/layout-resolver';

if (!import.meta.env.SSR) {
  const { initTheme } = await import('../lib/theme');
  initTheme();
}

createInertiaApp({
  resolve: (name): any => {
    const pages = import.meta.glob<any>('../pages/**/*.tsx', { eager: true });
    const page = pages[`../pages/${name}.tsx`];
    return resolvePageLayout(name, page);
  },

  setup({ el, App, props }) {
    const appElement = createElement(AstryxProviders, null, renderApp(App, props));

    if (el && el.hasChildNodes()) {
      hydrateRoot(el, appElement);
    } else {
      createRoot(el).render(appElement);
    }
  },
});
